import React from 'react';
import './AboutUs.css';
import advocatePhoto from '../../Images/Advocate_Img.png'; // Path to the downloaded image from the provided picture

const AboutUs = () => {
  const awards = [
    {
      title: "Award",
      text: "Comprehensive legal services across multiple practice areas, delivered with expertise and dedication"
    },
    {
      title: "Award",
      text: "Comprehensive legal services across multiple practice areas, delivered with expertise and dedication"
    }
  ];

  return (
    <section className="about-section" id="about">
      <div className="container">
        <div className="center-header">
          <div className="header-badge">Our Story</div>
          <h2 className="section-title">About Us</h2>
        </div>

        <div className="about-grid">
          <div className="image-container">
            <img 
              src={advocatePhoto} 
              alt="Portrait of Advocate" 
              className="advocate-image"
            />
          </div>

          <div className="content-container">
            <h3 className="content-title">Sernior Advocate</h3>
            <div className="content-body">
              <p>
                With over 18 years of distinguished legal practice, Senior Advocate Rajesh
                Kumar has established himself as one of the most respected legal minds in the
                country. His unwavering commitment to justice and client advocacy has resulted
                in landmark victories across multiple practice areas.
              </p>
              <p>
                A graduate of Harvard Law School, he brings international expertise combined
                with deep understanding of local legal frameworks. His approach combines
                meticulous preparation, strategic thinking, and passionate advocacy to deliver
                exceptional results for every client.
              </p>
            </div>

            <div className="awards-grid">
              {awards.map((award, index) => (
                <div key={index} className="award-card">
                  <div className="card-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                      <polyline points="9 11 12 14 20 6" />
                    </svg>
                  </div>
                  <h4 className="card-title">{award.title}</h4>
                  <p className="card-text">{award.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;